import {DuplicateOrderSummaries} from "../../types/DuplicateOrdersVettingResponse";

export class DuplicateOrdersNotificationDialogController {

    /** @ngInject */
    public constructor(private readonly duplicates: DuplicateOrderSummaries) {
    }
}
